import React, { useContext } from 'react';
import useDfcSurface from '../../hooks/useDfcSurface';
import { BracketWord } from '../Home/FitnessVillageHome/asaHomeStyle';
import { AsaColumn, AsaHeading, AsaScreen, FlowFrame } from './style';
import { AsaPurchaseContext } from './asaPurchaseContext';
import { CheckoutContext, CheckoutContextProps } from '../../context/CheckoutContext';

interface AsaFlowShellProps {
  lead: string;
  word: string;
  children: React.ReactNode;
}

/**
 * ASA's frame around an existing purchase page (`/packagePurchase`, `/membershipPurchase`).
 * The page inside keeps all of its logic; its checkout form and price card already have village
 * variants, and `FlowFrame` re-themes the one generic part, the voucher summary card.
 */
const AsaFlowShell: React.FC<AsaFlowShellProps> = ({ lead, word, children }) => {
  const surface = useDfcSurface();
  const { selectedVoucher } = useContext(CheckoutContext) as CheckoutContextProps;
  const price = selectedVoucher?.newPrice || selectedVoucher?.price || 0;
  return (
    <AsaPurchaseContext.Provider value={{ price }}>
      <AsaScreen surface={surface} data-testid="asa-flow">
        <AsaColumn>
          <AsaHeading surface={surface}>
            {lead} <BracketWord>[{word}]</BracketWord>
          </AsaHeading>
          <FlowFrame surface={surface}>{children}</FlowFrame>
        </AsaColumn>
      </AsaScreen>
    </AsaPurchaseContext.Provider>
  );
};

export default AsaFlowShell;
